import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@services/auth.service';

type JwtPayload = Record<string, unknown>;

function decodeJwtPayload(token: string): JwtPayload | null {
	const parts = token.split('.');
	if (parts.length < 2) return null;

	const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
	const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);

	try {
		const json = atob(padded);
		const parsed: unknown = JSON.parse(json);
		return parsed && typeof parsed === 'object' ? (parsed as JwtPayload) : null;
	} catch {
		return null;
	}
}

function normalizeRole(v: unknown): string {
	return String(v ?? '')
		.trim()
		.toLowerCase()
		.replace(/\s+/g, '_');
}

export const masterGuard: CanActivateFn = () => {
	const auth = inject(AuthService);
	const router = inject(Router);

	const token = auth.getToken();
	if (!token) return router.createUrlTree(['/auth/login']);

	const payload = decodeJwtPayload(token);

	const claimsRaw = payload?.['claims'];
	const claims =
		claimsRaw && typeof claimsRaw === 'object' ? (claimsRaw as Record<string, unknown>) : null;

	const role =
		normalizeRole(payload?.['role']) ||
		normalizeRole(payload?.['tokenRole']) ||
		normalizeRole(payload?.['userRole']) ||
		normalizeRole(claims?.['role']);

	const isMaster = role === 'master' || role === 'admin_master';

	if (!isMaster) return router.createUrlTree(['/infos/pets']);

	return true;
};
